import { connect } from 'react-redux';
import LineSelector from './LineSelector';
import { resetPhoneLines, togglePhoneLinesEditing, updatePhoneLines } from '../../modules/PhoneLines/actions';
import { goToSignUp } from '../../modules/Navigation/actions';
import { isLoadingSelector } from '../../modules/LoadingStatus/reducer';
import { hasErrorSelector, isFetchingSelector } from '../../modules/Subscriptions';
import { currentSubscriptionSelector, visibleSubscriptionsSelector } from '../../modules/Dashboard';
import { phoneLinesEditingSelector } from '../../modules/PhoneLines/selectors';

const mapStateToProps = state => ({
  isEditing: phoneLinesEditingSelector(state),
  isFailure: hasErrorSelector(state),
  isFetching: isFetchingSelector(state),
  subscriptions: visibleSubscriptionsSelector(state),
  selectedSubscription: currentSubscriptionSelector(state),
  isInitializingSignUp: isLoadingSelector(state, 'initSignUp'),
});

const mapDispatchToProps = {
  toggleEdition: togglePhoneLinesEditing,
  resetPhoneLines,
  updatePhoneLines,
  goToSignUp,
};

export default connect(mapStateToProps, mapDispatchToProps)(LineSelector);
